import { Seat, TransactionModel } from '@core/models';
import {
  ANALYTICS_ITEM_CATEGORIES,
  AnalyticsItem,
} from '@core/services/analytics';
import { buildCartItems } from '@features/pages/select-seat/_utils/cart-items.builder';

export function buildTransactionItems(
  transaction: TransactionModel,
  seats: Seat[]
): AnalyticsItem[] {
  const gameId = String(
    transaction.event?.pvEventId ?? transaction.eventId ?? ''
  );
  const matchup = transaction.event?.description ?? '';
  const items: AnalyticsItem[] = buildCartItems(seats, gameId, matchup);

  const upsell = transaction.event?.upsells?.find(
    candidate => candidate.buyerTypeId === transaction.buyerTypeId
  );
  if (upsell) {
    items.push({
      itemId: `upsell::${upsell.id}`,
      itemName: upsell.name,
      itemCategory: ANALYTICS_ITEM_CATEGORIES.UPSELL,
      price: upsell.price ?? undefined,
      quantity: 1,
    });
  }

  const tdcTransaction = transaction.tdcTransaction;
  if (tdcTransaction?.hasInsuranceRainout) {
    items.push({
      itemId: 'rainout_insurance',
      itemName: 'Rainout Insurance',
      itemCategory: ANALYTICS_ITEM_CATEGORIES.RAINOUT_INSURANCE,
      price: tdcTransaction.insuranceRainoutPrice ?? undefined,
      quantity: 1,
    });
  }

  return items;
}
